import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  JoinColumn,
  ManyToOne,
  OneToMany,
  Index,
} from "typeorm";
import { LicenseRequest, User, WorkLicenseType } from ".";
import { LicenseTypeQuestion } from "./LicenseTypeQuestion";

@Entity()
@Index(["songMaster", "commercial", "location", "name"], { unique: true })
export class LicenseType {
  @PrimaryGeneratedColumn() id: number;

  @Column("varchar", { length: 10 })
  songMaster: string;

  @Index()
  @Column("tinyint")
  commercial: boolean;

  @Column("varchar", { length: 5 })
  location: string;
  @Column("varchar") name: string;
  @Column("tinyint") potentiallyAutomated: boolean;

  @Column("int", { nullable: true })
  createdById: number;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;

  @Column("int", { nullable: true })
  updatedById: number;

  @ManyToOne(() => User)
  @JoinColumn()
  updatedBy: User;

  @Column("text") compositionRate: string;
  @Column("text") masterRate: string;
  @Column("text") description: string;
  @Column("text") helpText: string;

  @Column("text", { select: false })
  contract: string;

  @OneToMany(
    () => WorkLicenseType,
    (workLicenseType) => workLicenseType.licenseType
  )
  workLicenseTypes: WorkLicenseType[];

  @OneToMany(
    () => LicenseRequest,
    (licenseRequest) => licenseRequest.licenseType
  )
  @JoinColumn()
  licenseRequests: [LicenseRequest];

  @OneToMany(
    () => LicenseTypeQuestion,
    (licenseTypeQuestion) => licenseTypeQuestion.licenseType
  )
  @JoinColumn()
  licenseTypeQuestions: [LicenseTypeQuestion];

  @Column("tinyint") canBatch: boolean;

  @Column("datetime") createdAt: Date;
  @Column("datetime") updatedAt: Date;

  assignAttributesFromObject(obj: any) {
    this.commercial =
      obj.commercial !== undefined ? obj.commercial : this.commercial;
    this.potentiallyAutomated =
      obj.potentiallyAutomated !== undefined
        ? obj.potentiallyAutomated
        : this.potentiallyAutomated;
    this.songMaster = obj.songMaster ? obj.songMaster : this.songMaster;
    this.location = obj.location ? obj.location : this.location;
    this.name = obj.name ? obj.name : this.name;
    this.contract = obj.contract ? obj.contract : this.contract;
    this.compositionRate = obj.compositionRate
      ? obj.compositionRate
      : this.compositionRate;
    this.masterRate = obj.masterRate ? obj.masterRate : this.masterRate;
    this.description = obj.description ? obj.description : this.description;
    this.helpText = obj.helpText ? obj.helpText : this.helpText;
    this.canBatch = obj.canBatch ? obj.canBatch : this.canBatch;
    this.createdAt = obj.createdAt ? obj.createdAt : this.createdAt;
    this.updatedAt = obj.updatedAt ? obj.updatedAt : this.updatedAt;
    this.createdBy = obj.createdBy ? obj.createdBy : this.createdBy;
    this.updatedBy = obj.updatedBy ? obj.updatedBy : this.updatedBy;
    return this;
  }
}
